import React from "react";
import cx from "classnames";
import { get } from "lodash";

import TruncateWithTooltip from "src/components/truncateWithTooltip";

import { User } from "src/types/users";
import { Analytics } from "src/types/reports";

import styles from "./sharesCard.module.scss";
const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

export interface SharesCardItem {
  user: User;
  analytics: Analytics;
}

export interface SharesCardProps {
  item: SharesCardItem;
}

export const SharesCard: React.FC<SharesCardProps> = ({ item }) => {
  const { user, analytics } = item;
  return (
    <div className={cx(styles.card, {
      [styles.disabled]: !get(user, 'enabled', true),
    })}>
      <img
        src={user.icon?.thumbnail || DefaultAssetIcon}
        className={`${styles.thumbnailIcon} ${styles.contactIcon}`}
        alt={`${user.firstName} ${user.lastName}`}
      />
      <div className={styles.content}>
        <div className={styles.titleRow}>
          <TruncateWithTooltip
            text={`${user.firstName} ${user.lastName}`}
            className={styles.title}
          />
          {!get(user, 'enabled', true) && (
            <p className={styles.titleDeactivated}>{'(deactivated)'}</p>
          )}
        </div>
        <div className={styles.metrics}>
          <span>{analytics.shares || 0} Shares</span>
          <span>{analytics.assets || 0} Assets</span>
          <span>{analytics.recipients || 0} Recipients</span>
        </div>
        <div className={styles.meta}>
          {user.lastActivityDate && (
            <>
              Last Active on:{" "}
              {new Date(user.lastActivityDate).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              })}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
